import {
    FETCH_ALL_F2F_PERFORMERS_START,
    FETCH_ALL_F2F_PERFORMERS_SUCCESS,
    FETCH_ALL_F2F_PERFORMERS_FAILURE
} from "./ActionConstant";

export function fetchAllF2FPerformersStart(data) {
  return {
    type: FETCH_ALL_F2F_PERFORMERS_START,
    data
  };
}

export function fetchAllF2FPerformersSuccess(data) {
  return {
    type: FETCH_ALL_F2F_PERFORMERS_SUCCESS,
    data
  };
}

export function fetchAllF2FPerformersFailure(error) {
  return {
    type: FETCH_ALL_F2F_PERFORMERS_FAILURE,
    error
  };
}
